export default __webpack_public_path__ + "static/media/image-bus.816ff0d1.png";